import axios from "../axios";
import { fetchMasterItems } from "./masters";

const PODS_URL = "/api/pods";
const DISCLAIMER_URL = "/disclaimers";
const INFO_QUESTION_URL = "/api/masters/info-questions/get-items-by-id";

export function fetchPOD(id: string) {
  return axios({
    url: PODS_URL + `/${id}`,
    method: "get",
  });
}

export function fetchPODDisclaimers(ids: string[]) {
  return fetchMasterItems(DISCLAIMER_URL, ids);
}

export function fetchPODInfoQuestions(ids: string[]) {
  return axios({
    url: INFO_QUESTION_URL,
    method: "post",
    data: ids,
  });
}
